import { Link } from 'react-router-dom';

const stats = [
  { value: '5000+', label: '漫画资源', icon: 'ri-book-line' },
  { value: '200万+', label: '活跃读者', icon: 'ri-user-line' },
  { value: '99.9%', label: '服务稳定性', icon: 'ri-shield-check-line' },
  { value: '24h', label: '急速更新', icon: 'ri-timer-line' },
];

const ctaBgImage = 'https://readdy.ai/api/search-image?query=Dreamy%20fantasy%20reading%20atmosphere%20with%20floating%20books%20and%20magical%20sparkles%2C%20warm%20golden%20glow%2C%20soft%20bokeh%20effect%2C%20ethereal%20and%20inviting%2C%20abstract%20artistic%20composition%2C%20no%20text&width=1600&height=500&seq=cta-bg-2026&orientation=landscape';

export default function CtaSection() {
  return (
    <section className="relative py-16 md:py-20 overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${ctaBgImage})` }}
      />
      <div className="absolute inset-0 bg-gradient-to-r from-primary-900/90 via-primary-800/85 to-primary-900/90" />

      <div className="relative z-10 max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-background-50 font-heading mb-3">
            加入妖精漫画，开启奇幻阅读之旅
          </h2>
          <p className="text-background-50/80 text-sm md:text-base max-w-xl mx-auto">
            超过200万漫画爱好者已经加入，你还在等什么？立即开始免费阅读！
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 mb-10">
          {stats.map((stat, idx) => (
            <div key={idx} className="text-center">
              <div className="w-10 h-10 mx-auto mb-3 flex items-center justify-center rounded-full bg-background-50/15 text-background-50">
                <i className={`${stat.icon} text-lg`}></i>
              </div>
              <div className="text-2xl md:text-3xl font-bold text-background-50 font-heading">{stat.value}</div>
              <div className="text-xs text-background-50/70 mt-1">{stat.label}</div>
            </div>
          ))}
        </div>

        <div className="flex items-center justify-center">
          <Link
            to="/category/fantasy"
            className="btn-primary text-sm px-10 py-3 bg-accent-500 hover:bg-accent-600"
          >
            <i className="ri-rocket-line mr-2"></i>
            免费开始阅读
          </Link>
        </div>
      </div>
    </section>
  );
}